module.exports = __webpack_public_path__ + "/images/screen-vendedores-informes.34ad229.webp";